export const API_PATH = {
  production: {
    API_ROOT: `${window.location.origin}/gateway/`,
    // S3_API_ROOT: `${window.location.origin}`,
  },
  development: {
     // API_ROOT: 'https://qa-nsws.investindia.gov.in/gateway/', //QA URL
     // API_ROOT: "https://dev-nsws.investindia.gov.in/gateway/", //Dev URL
    API_ROOT: 'https://uat-nsws.investindia.gov.in/gateway/', //UAT URL
    //  API_ROOT: 'https://mpf-nsws.investindia.gov.in/gateway/', //MPF URL
    // API_ROOT: 'https://www.demo.nsws.gov.in/gateway/', //demo PPE-stage URL
    // S3_API_ROOT: '',
  },
};

//form-builder seperate gateway
export const API_PATH_FB = {
    production: {
      API_ROOT_FB: `${window.location.origin}/gateway-sec/`,
      // S3_API_ROOT: `${window.location.origin}`,
    },
    development: {
       // API_ROOT: 'https://qa-nsws.investindia.gov.in/gateway/', //QA URL
       // API_ROOT: "https://dev-nsws.investindia.gov.in/gateway/", //Dev URL
      API_ROOT_FB: 'https://uat-nsws.investindia.gov.in/gateway-sec/', //UAT URL
      //  API_ROOT: 'https://mpf-nsws.investindia.gov.in/gateway/', //MPF URL
      // API_ROOT: 'https://www.demo.nsws.gov.in/gateway/', //demo PPE-stage URL
      // S3_API_ROOT: '',
    },
  };

// export const logoLink = '';
export const docUrl=(origin) =>{
    switch (origin) {
        case "https://www.ppe.nsws.gov.in":
            return 'https://www.ppe-nodal-authority.nsws.gov.in/';
        case "https://www.nsws.gov.in":
            return `https://www.nodal-authority.nsws.gov.in/`;
        case "https://www.demo.nsws.gov.in":
            return `https://www.demo-nodal-authority.nsws.gov.in/`;
        default:
            return `https://uat-nsws-mnstrportal.investindia.gov.in/`;
    }
};

export const  bisValidationUrl=(origin) =>{
    switch (origin) {
        case "https://www.ppe.nsws.gov.in":
            return 'https://www.ppe-nodal-authority.nsws.gov.in/';
        case "https://www.nsws.gov.in":
            return `https://www.nodal-authority.nsws.gov.in/`;
        case "https://www.demo.nsws.gov.in":
            return `https://www.demo-nodal-authority.nsws.gov.in/`;
        default:
            return `https://uat-nsws-mnstrportal.investindia.gov.in/`;
    }
};

export const  dotValidationUrl=(origin) =>{
    switch (origin) {
        case "https://www.ppe.nsws.gov.in":
            return 'https://www.ppe-nodal-authority.nsws.gov.in/';
        case "https://www.nsws.gov.in":
            return `https://www.nodal-authority.nsws.gov.in/`;
        case "https://www.demo.nsws.gov.in":
            return `https://www.demo-nodal-authority.nsws.gov.in/`;
        default:
            return `https://uat-nsws-mnstrportal.investindia.gov.in/`;
    }
};

export const  sihValidationUrl=(origin) =>{
    switch (origin) {

        case "https://www.nsws.gov.in":
            return `https://api.startupindia.gov.in/`;
        default:
            return `https://api-uat.startupindia.gov.in/`;
    }
};

//drupal image api path
export const baseUrlDrupal=() =>{
    const origin = window.location.origin;
    switch (origin){
        case "https://dev-nsws.investindia.gov.in":
            return 'https://dev-nsws.investindia.gov.in';
        case "https://mpf-nsws.investindia.gov.in":
            return 'https://mpf-nsws.investindia.gov.in';
        case "https://qa-nsws.investindia.gov.in":
            return `https://qa-nsws.investindia.gov.in`;
        case "https://uat-nsws.investindia.gov.in":
            return `https://uat-nsws.investindia.gov.in`;
        case "https://www.ppe.nsws.gov.in":
            return `https://www.ppe.nsws.gov.in`;
        case "https://www.nsws.gov.in":
            return `https://www.nsws.gov.in`;
        case "https://www.demo.nsws.gov.in":
            return `https://www.demo.nsws.gov.in`;
        default:
            return `https://uat-nsws.investindia.gov.in`;
    }
};

export const ENVIRONMENTS = {
    'http://localhost:3000': 'mpf',
    'https://mpf-nsws.investindia.gov.in': 'mpf',
    'https://qa-nsws.investindia.gov.in': 'qa',
    'https://uat-nsws.investindia.gov.in': 'uat',
    'https://www.ppe.nsws.gov.in': 'ppe',
    'https://www.demo.nsws.gov.in': 'demo',
    'https://www.nsws.gov.in': 'prod'
}